var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { attr, observable } from "@microsoft/fast-element";
import { FoundationElement } from "@microsoft/fast-foundation";
/** ActionsMenu Class definition */
export class ActionsMenu extends FoundationElement {
    constructor() {
        super(...arguments);
        /**
         * Menu items
         */
        this.menuItems = [];
        /** Boolean indicating if fast-anchored-region component should be used to determine position */
        this.useFastAnchoredRegion = false;
        /**
         * Position fixed or not
         */
        this.fixedPosition = false;
        /** Default vertical placement */
        this.defaultVerticalPosition = "bottom";
        /** Default Horizontal placement */
        this.defaultHorizontalPosition = "end";
        /** Flag indicating if position update is in progress, used to avoid queuing multiple update tasks */
        this.isUpdatingPosition = false;
        /**
         * Event handler for key down
         */
        this.keyDownHandler = (e) => {
            if (e.key === 'Escape') {
                this.referrerButton && this.referrerButton.focus();
                this.$emit("dismiss-menu");
            }
            else {
                if (e.key === 'Tab') {
                    this.referrerButton && this.referrerButton.focus();
                    e.preventDefault();
                    e.stopProgagation();
                }
                if (this.fluentMenu) {
                    const target = e.target;
                    Array.from(this.fluentMenu.children).map((element, index) => {
                        if (e.key === 'Enter') {
                            this.referrerButton && this.referrerButton.focus();
                        }
                        if (element === target) {
                            e.stopPropagation();
                        }
                    });
                }
            }
            return true;
        };
        this.initMenuPositioning = () => {
            this.setMenuPosition();
            document.addEventListener("scroll", this.updatePosition);
            window.addEventListener("resize", this.updatePosition);
        };
        /**
         * Sets the position styles for the menu
         */
        this.setMenuPosition = () => {
            if (!this.referrerButton || !this.menu || !this.fluentMenu || !this.referrerButtonRect || !this.parentRect) {
                return;
            }
            const refPosition = this.referrerButtonRect;
            // logic includes correction values of 1 and 2 px to make the UI render in the correct position
            let verticalPosition;
            if (this.defaultVerticalPosition === "top") {
                verticalPosition = `top:${refPosition.top - this.parentRect.top + window.scrollY - 2 - this.fluentMenu.clientHeight}px;`;
            }
            else {
                verticalPosition =
                    refPosition.bottom + this.fluentMenu.clientHeight > window.innerHeight
                        ? `top:${refPosition.top - this.parentRect.top + window.scrollY - 2 - this.fluentMenu.clientHeight}px;`
                        : `top:${refPosition.bottom - this.parentRect.top + window.scrollY + 1}px;`;
            }
            this.menu.setAttribute("style", `position:absolute;${verticalPosition}${this.getHorizontalPosition(refPosition)}`);
            this.isUpdatingPosition = false;
        };
        /** Recalculates and updates menu position based on referrer button position */
        this.updatePosition = () => {
            if (!this.isUpdatingPosition) {
                window.requestAnimationFrame(() => {
                    this.setMenuPosition();
                });
                this.isUpdatingPosition = true;
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        if (!this.fluentMenu) {
            return;
        }
        if (!this.useFastAnchoredRegion) {
            this.initMenuPositioning();
        }
        if (this.fluentMenu && this.fluentMenu.children.length) {
            setTimeout(() => {
                var _a;
                ((_a = this.fluentMenu) === null || _a === void 0 ? void 0 : _a.children[0]).focus();
            }, 100);
            this.$emit("shown-menu");
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (!this.useFastAnchoredRegion) {
            document.removeEventListener("scroll", this.updatePosition);
            window.removeEventListener("resize", this.updatePosition);
        }
    }
    /** Gets horizontal positioning styles based on document direction */
    getHorizontalPosition(refPosition) {
        const docWidth = document.documentElement.clientWidth;
        if (!this.fluentMenu || !this.parentRect) {
            return "";
        }
        if (document.dir === "rtl" || this.defaultHorizontalPosition === "start") {
            return docWidth - refPosition.right + this.fluentMenu.clientWidth <= window.innerWidth
                ? `right:${this.parentRect.right - refPosition.right}px`
                : `left:${refPosition.left - this.parentRect.left}px;`;
        }
        return refPosition.left + this.fluentMenu.clientWidth <= window.innerWidth
            ? `left:${refPosition.left - this.parentRect.left}px;`
            : `right:${this.parentRect.right - refPosition.right}px;`;
    }
}
__decorate([
    observable,
    __metadata("design:type", Array)
], ActionsMenu.prototype, "menuItems", void 0);
__decorate([
    observable,
    __metadata("design:type", HTMLElement)
], ActionsMenu.prototype, "referrerButton", void 0);
__decorate([
    observable,
    __metadata("design:type", DOMRect)
], ActionsMenu.prototype, "parentRect", void 0);
__decorate([
    observable,
    __metadata("design:type", DOMRect)
], ActionsMenu.prototype, "referrerButtonRect", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActionsMenu.prototype, "useFastAnchoredRegion", void 0);
__decorate([
    attr({ mode: "boolean" }),
    __metadata("design:type", Object)
], ActionsMenu.prototype, "fixedPosition", void 0);
__decorate([
    attr,
    __metadata("design:type", Object)
], ActionsMenu.prototype, "defaultVerticalPosition", void 0);
__decorate([
    attr,
    __metadata("design:type", Object)
], ActionsMenu.prototype, "defaultHorizontalPosition", void 0);
